module.exports = __webpack_public_path__ + "static/media/help-header-03@3x.1ed5d15f.png";